import cx from 'clsx';
import React, { CSSProperties } from 'react';

import { WinAnimation } from '@ezugi/components';
import { DeviceInfo } from '@ezugi/utils/src';

import {
  resultMessageContainer, resultMessageContainerMobile, styledAmount, winMessageStyle,
  winMessageStyleMobile,
} from './GameResults.css';
import { ResultMessageTips } from './ResultMessageTips';
import { WinAmountValue, useGameResults } from './useGameResults';

export type ResultMessageProps = {
  className?: string;
  children?: React.ReactNode;
  style?: CSSProperties;
};

export const WinMessageBasic = ({ winAmount } : {winAmount: WinAmountValue}) => (
  <div
    className={cx(winMessageStyle, { [winMessageStyleMobile]: DeviceInfo.isHandheld })}
    data-name="win-message"
    data-e2e="win-message"
  >
    <span data-e2e="win-message-label">{winAmount.label}</span>
    <div
      data-e2e="win-message-amount"
      className={styledAmount}
    >
      {winAmount.value}
    </div>
  </div>
);

const ResultMessage = ({ className, style, children, ...props }: ResultMessageProps) => {
  const { shouldCelebrate, winAmount, isWinner } = useGameResults();

  return (
    <div
      style={style}
      className={cx(
        resultMessageContainer,
        { [resultMessageContainerMobile]: DeviceInfo.isHandheld },
        className,
      )}
      {...props}
    >
      {shouldCelebrate && <WinAnimation />}

      {children ?? (isWinner ? <WinMessageBasic winAmount={winAmount} /> : null)}

      <ResultMessageTips />
    </div>
  );
};

export default ResultMessage;
